module.exports = __webpack_public_path__ + "static/media/shield.ce96b146.svg";